<template lang="pug" src="./tab-home-about.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tab/tab-home-about/tab-home-about.vue